import { GET_HOLIDAY_REQUESTS, SET_HOLIDAY_REQUEST } from "./types";
import firebase from "firebase/app";
export const getTotalUserReports = () => {
    return dispatch => {
        dispatch({ type: GET_HOLIDAY_REQUESTS.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: GET_HOLIDAY_REQUESTS.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("subjects/reports/")
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_HOLIDAY_REQUESTS.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_HOLIDAY_REQUESTS.FAIL });
        }
    };
};

export const setHolidayRequest = (uid = null, timestamp = null, approvedDenied = null) => {
    let child = { status: approvedDenied };
    return dispatch => {
        dispatch({ type: SET_HOLIDAY_REQUEST.REQUEST });
        if (uid === null || timestamp === null || approvedDenied === null) {
            dispatch({ type: SET_HOLIDAY_REQUEST.FAIL });
        } else {
            try {
                firebase.auth().onAuthStateChanged(user => {
                    if (user === null) {
                        dispatch({ type: SET_HOLIDAY_REQUEST.FAIL });
                    } else {
                        firebase
                            .database()
                            .ref(`subjects/reports/${uid}/reports/holiday_request/`)
                            .child(timestamp)
                            .update(child);

                        dispatch({ type: SET_HOLIDAY_REQUEST.SUCCESS });
                    }
                });
            } catch (e) {
                dispatch({ type: SET_HOLIDAY_REQUEST.FAIL });
            }
        }
    };
};
